"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var MetadataReportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(MetadataReportDTO, _DomainObject_1$Domai);

  /**
   * DTO used for metadata report
   */
  function MetadataReportDTO(productExternalId, productName, siteExternalId, siteName, productActive) {
    var _this;

    var addToPortfolioDate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    _classCallCheck(this, MetadataReportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetadataReportDTO).call(this));
    _this.productExternalId = productExternalId;
    _this.productName = productName;
    _this.siteExternalId = siteExternalId;
    _this.siteName = siteName;
    _this.productActive = productActive;
    _this.addToPortfolioDate = addToPortfolioDate;
    return _this;
  }

  return MetadataReportDTO;
}(DomainObject_1.DomainObject);

exports.MetadataReportDTO = MetadataReportDTO;

MetadataReportDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(MetadataReportDTO.name);
  return {
    productExternalId: builder.str('productExternalId'),
    productName: builder.str('productName'),
    siteExternalId: builder.str('siteExternalId'),
    siteName: builder.str('siteName'),
    productActive: builder.bool('productActive'),
    addToPortfolioDate: builder.opt(builder.date('addToPortfolioDate', DateParser_1.DateParser.ISO_PATTERN))
  };
}();